export default "__VITE_ASSET__4b5b80ff__"